export default "__VITE_ASSET__uvj9BRhf__"